(function () {
  'use strict';

  const WISHLIST_KEY = 'limenda_wishlist';
  let toastTimer;

  const getWishlist = () => {
    try {
      return JSON.parse(localStorage.getItem(WISHLIST_KEY) || '[]');
    } catch (e) {
      return [];
    }
  };

  const setWishlist = (items) => {
    localStorage.setItem(WISHLIST_KEY, JSON.stringify(items));
  };

  const showToast = (message) => {
    const toast = document.querySelector('[data-l-pdp-toast]');
    if (!toast) return;
    const textEl = toast.querySelector('[data-l-pdp-toast-message]');
    if (textEl && message) textEl.textContent = message;
    toast.classList.add('is-visible');
    toast.setAttribute('aria-hidden', 'false');
    clearTimeout(toastTimer);
    toastTimer = setTimeout(() => hideToast(), 5000);
  };

  const hideToast = () => {
    const toast = document.querySelector('[data-l-pdp-toast]');
    if (!toast) return;
    toast.classList.remove('is-visible');
    toast.setAttribute('aria-hidden', 'true');
  };

  const toggleWishlist = (handle, buttons) => {
    if (!handle) return;
    const list = getWishlist();
    const index = list.indexOf(handle);
    const active = index === -1 ? (list.push(handle), true) : (list.splice(index, 1), false);
    setWishlist(list);
    buttons.forEach((btn) => {
      btn.classList.toggle('is-active', active);
      btn.setAttribute('aria-pressed', active ? 'true' : 'false');
    });
    showToast(active ? 'Zu Ihren Favoriten hinzugefügt.' : 'Aus Favoriten entfernt.');
  };

  const syncWishlistState = (root, handle) => {
    const buttons = root.querySelectorAll('[data-l-pdp-wish]');
    const active = getWishlist().includes(handle);
    buttons.forEach((btn) => {
      btn.classList.toggle('is-active', active);
      btn.setAttribute('aria-pressed', active ? 'true' : 'false');
    });
  };

  const waitForAlpineStore = (storeName, attempts = 20) =>
    new Promise((resolve) => {
      const check = (left) => {
        if (window.Alpine?.store?.(storeName)) {
          resolve(window.Alpine.store(storeName));
          return;
        }
        if (left <= 0) {
          resolve(null);
          return;
        }
        setTimeout(() => check(left - 1), 100);
      };
      check(attempts);
    });

  const openCart = async () => false;

  const updateHeaderCartCount = (count) => {
    const bubble = document.getElementById('l-header-cart-count');
    if (!bubble) return;
    bubble.dataset.value = String(count);
    let span = bubble.querySelector('span[aria-hidden="true"]');
    if (count > 0) {
      if (!span) {
        span = document.createElement('span');
        span.setAttribute('aria-hidden', 'true');
        bubble.appendChild(span);
      }
      span.textContent = count < 100 ? String(count) : '99+';
    } else if (span) {
      span.remove();
    }
    document.querySelectorAll('.l-header__action--cart .count_item, #cart-icon-bubble.count_item').forEach((el) => el.remove());
  };

  const refreshCartUi = async (itemCount) => {
    try {
      const cart = await fetch('/cart.js', { headers: { Accept: 'application/json' } }).then((r) => r.json());
      const count = cart.item_count ?? itemCount ?? 0;
      updateHeaderCartCount(count);
      document.dispatchEvent(new CustomEvent('eurus:cart:items-changed'));
      return count;
    } catch (e) {
      if (typeof itemCount === 'number') updateHeaderCartCount(itemCount);
      return itemCount;
    }
  };

  const setButtonLoading = (button, loading, label) => {
    if (!button) return;
    if (loading) {
      button.dataset.originalText = button.textContent;
      button.disabled = true;
      button.classList.add('is-loading');
      if (label) button.textContent = label;
    } else {
      button.disabled = false;
      button.classList.remove('is-loading');
      if (button.dataset.originalText) button.textContent = button.dataset.originalText;
    }
  };

  const addToCart = async (form, button) => {
    if (!form) return;

    const variantId = form.querySelector('[name="id"]')?.value;
    if (!variantId) {
      alert('Bitte wählen Sie eine Variante.');
      return;
    }

    setButtonLoading(button, true, 'Wird hinzugefügt...');

    try {
      const formData = new FormData(form);
      const response = await fetch('/cart/add.js', {
        method: 'POST',
        headers: {
          Accept: 'application/json',
          'X-Requested-With': 'XMLHttpRequest',
        },
        body: formData,
      });

      const data = await response.json();

      if (!response.ok || data.status === 422) {
        alert(data.description || data.message || 'Produkt konnte nicht hinzugefügt werden.');
        return;
      }

      await refreshCartUi(data.quantity);
      showToast('Produkt wurde in den Warenkorb gelegt.');
    } catch (error) {
      console.error(error);
      alert('Ein Fehler ist aufgetreten. Bitte versuchen Sie es erneut.');
    } finally {
      setButtonLoading(button, false);
    }
  };

  const initPdp = () => {
    document.querySelector('[data-l-pdp-toast-close]')?.addEventListener('click', hideToast);

    document.querySelectorAll('[data-l-pdp]').forEach((root) => {
      if (root.dataset.lPdpInit) return;
      root.dataset.lPdpInit = '1';

      const jsonEl = root.querySelector('[data-l-product-json]');
      if (!jsonEl) return;
      const product = JSON.parse(jsonEl.textContent);
      const form = root.querySelector('.l-pdp__form') || root.querySelector('form[action*="/cart/add"]');
      const mainImg = root.querySelector('[data-l-pdp-main-img]');
      const priceEl = root.querySelector('[data-l-pdp-price]');
      const compareEl = root.querySelector('[data-l-pdp-compare]');
      const variantInput = root.querySelector('[data-l-pdp-variant-id]');
      const atcBtn = root.querySelector('[data-l-pdp-atc]');
      const atcLabel = root.querySelector('[data-l-pdp-atc-label]');
      const thumbs = root.querySelectorAll('[data-l-pdp-thumb]');
      const prevBtn = root.querySelector('[data-l-pdp-prev]');
      const nextBtn = root.querySelector('[data-l-pdp-next]');
      const qtySelect = root.querySelector('[data-l-pdp-qty]');
      const stickyQty = root.querySelector('[data-l-pdp-sticky-qty]');
      const sticky = root.querySelector('[data-l-pdp-sticky]');
      const stickyPrice = root.querySelector('[data-l-pdp-sticky-price]');
      const stickyCompare = root.querySelector('[data-l-pdp-sticky-compare]');
      const stickyAtc = root.querySelector('[data-l-pdp-sticky-atc]');
      const buyRow = root.querySelector('[data-l-pdp-buy-row]');
      const swatches = root.querySelectorAll('[data-l-pdp-swatch]');

      let activeIndex = 0;
      const media = product.media && product.media.length ? product.media : [];
      const moneyFormat = root.dataset.moneyFormat || '${{amount}}';

      const formatMoney = (cents) => {
        if (window.Shopify && typeof Shopify.formatMoney === 'function') {
          return Shopify.formatMoney(cents, moneyFormat);
        }
        return (cents / 100).toFixed(2).replace('.', ',') + ' €';
      };

      const applyMainImage = (src, alt) => {
        if (!mainImg || !src) return;
        mainImg.src = src;
        mainImg.removeAttribute('srcset');
        mainImg.removeAttribute('sizes');
        if (alt) mainImg.alt = alt;
      };

      const setMedia = (index) => {
        if (!mainImg) return;
        const thumb = thumbs[index];
        const thumbSrc = thumb?.getAttribute('data-media-src') || thumb?.dataset?.mediaSrc;
        if (thumbSrc) {
          activeIndex = index;
          applyMainImage(thumbSrc, thumb?.getAttribute('aria-label') || product.title);
          thumbs.forEach((t, i) => t.classList.toggle('is-active', i === index));
          const stickyThumb = root.querySelector('.l-pdp-sticky__thumb');
          if (stickyThumb) {
            stickyThumb.src = thumbSrc.replace(/width=\d+/, 'width=80');
          }
          return;
        }
        if (!media.length) return;
        activeIndex = (index + media.length) % media.length;
        const item = media[activeIndex];
        if (!item) return;
        const src = item.preview_image?.src || item.src || item.preview_image;
        if (typeof src === 'string') {
          applyMainImage(src, item.alt || product.title);
        }
        thumbs.forEach((t, i) => t.classList.toggle('is-active', i === activeIndex));
      };

      const setVariant = (variant) => {
        if (!variant) return;
        if (variantInput) variantInput.value = variant.id;
        if (priceEl) priceEl.textContent = formatMoney(variant.price);
        if (stickyPrice) stickyPrice.textContent = formatMoney(variant.price);
        if (compareEl) {
          if (variant.compare_at_price && variant.compare_at_price > variant.price) {
            compareEl.textContent = formatMoney(variant.compare_at_price);
            compareEl.hidden = false;
            if (stickyCompare) {
              stickyCompare.textContent = formatMoney(variant.compare_at_price);
              stickyCompare.hidden = false;
            }
          } else {
            compareEl.hidden = true;
            if (stickyCompare) stickyCompare.hidden = true;
          }
        }
        if (atcBtn) {
          atcBtn.disabled = !variant.available;
          atcBtn.classList.toggle('is-disabled', !variant.available);
        }
        if (stickyAtc) stickyAtc.disabled = !variant.available;
        if (atcLabel) {
          atcLabel.textContent = variant.available
            ? atcBtn?.dataset.labelAvailable || 'In den Warenkorb'
            : atcBtn?.dataset.labelSoldout || 'Ausverkauft';
        }
        if (variant.featured_media) {
          const idx = media.findIndex((m) => m.id === variant.featured_media.id);
          if (idx >= 0) setMedia(idx);
        }
        swatches.forEach((sw) => {
          sw.classList.toggle('is-active', sw.dataset.optionValue === variant.options[parseInt(sw.dataset.optionIndex, 10)]);
        });
      };

      const findVariant = (options) =>
        product.variants.find((v) => v.options.every((opt, i) => opt === options[i]));

      thumbs.forEach((thumb, i) => {
        thumb.addEventListener('click', (e) => {
          e.preventDefault();
          setMedia(i);
        });
      });
      prevBtn?.addEventListener('click', () => setMedia(activeIndex - 1));
      nextBtn?.addEventListener('click', () => setMedia(activeIndex + 1));

      root.querySelector('[data-l-pdp-thumb-up]')?.addEventListener('click', () => {
        root.querySelector('[data-l-pdp-thumbs]')?.scrollBy({ top: -80, behavior: 'smooth' });
      });
      root.querySelector('[data-l-pdp-thumb-down]')?.addEventListener('click', () => {
        root.querySelector('[data-l-pdp-thumbs]')?.scrollBy({ top: 80, behavior: 'smooth' });
      });

      swatches.forEach((sw) => {
        sw.addEventListener('click', () => {
          const idx = parseInt(sw.dataset.optionIndex, 10);
          const current = product.variants.find((v) => String(v.id) === String(variantInput?.value)) || product.variants[0];
          const options = [...current.options];
          options[idx] = sw.dataset.optionValue;
          const variant = findVariant(options);
          if (variant) setVariant(variant);
        });
      });

      const syncQty = (value) => {
        const qtyInput = form?.querySelector('[name="quantity"]');
        if (qtyInput) qtyInput.value = value;
        if (qtySelect) qtySelect.value = value;
        if (stickyQty) stickyQty.value = value;
      };

      qtySelect?.addEventListener('change', () => syncQty(qtySelect.value));
      stickyQty?.addEventListener('change', () => syncQty(stickyQty.value));

      if (form) {
        form.addEventListener('submit', (e) => {
          e.preventDefault();
          addToCart(form, atcBtn);
        });
      }

      atcBtn?.addEventListener('click', (e) => {
        e.preventDefault();
        addToCart(form, atcBtn);
      });

      stickyAtc?.addEventListener('click', () => addToCart(form, stickyAtc));

      root.querySelectorAll('[data-l-pdp-wish]').forEach((btn) => {
        btn.addEventListener('click', (e) => {
          e.preventDefault();
          toggleWishlist(product.handle, root.querySelectorAll('[data-l-pdp-wish]'));
        });
      });

      root.querySelectorAll('[data-l-pdp-reviews-link]').forEach((link) => {
        link.addEventListener('click', (e) => {
          const target = document.getElementById('reviews');
          if (!target) return;
          e.preventDefault();
          target.scrollIntoView({ behavior: 'smooth', block: 'start' });
        });
      });

      const reviewsSection = root.querySelector('[data-l-pdp-reviews]');
      if (reviewsSection) {
        const filterBtns = reviewsSection.querySelectorAll('[data-l-pdp-review-filter]');
        const reviewItems = reviewsSection.querySelectorAll('[data-l-pdp-review-item]');
        const emptyEl = reviewsSection.querySelector('[data-l-pdp-review-empty]');

        const applyReviewFilter = (filter) => {
          let visible = 0;
          reviewItems.forEach((item) => {
            const tags = (item.getAttribute('data-review-tags') || 'all').split(',');
            const show = filter === 'all' || tags.includes(filter);
            item.hidden = !show;
            if (show) visible += 1;
          });
          if (emptyEl) emptyEl.hidden = visible > 0;
          filterBtns.forEach((btn) => {
            btn.classList.toggle('is-active', btn.getAttribute('data-l-pdp-review-filter') === filter);
          });
        };

        filterBtns.forEach((btn) => {
          btn.addEventListener('click', () => {
            applyReviewFilter(btn.getAttribute('data-l-pdp-review-filter') || 'all');
          });
        });
      }

      const closeModals = () => {
        root.querySelectorAll('[data-l-pdp-modal]').forEach((modal) => {
          modal.hidden = true;
          modal.setAttribute('aria-hidden', 'true');
        });
        document.body.classList.remove('l-pdp-modal-open');
      };

      root.querySelectorAll('[data-l-pdp-campaign]').forEach((btn) => {
        btn.addEventListener('click', () => {
          const id = btn.dataset.lPdpCampaign;
          const modal = root.querySelector(`[data-l-pdp-modal="${id}"]`);
          if (!modal) return;
          closeModals();
          modal.hidden = false;
          modal.setAttribute('aria-hidden', 'false');
          document.body.classList.add('l-pdp-modal-open');
        });
      });

      root.querySelectorAll('[data-l-pdp-modal-close]').forEach((btn) => {
        btn.addEventListener('click', closeModals);
      });

      document.addEventListener('keydown', (e) => {
        if (e.key === 'Escape' && root.querySelector('[data-l-pdp-modal]:not([hidden])')) {
          closeModals();
        }
      });

      if (buyRow && sticky && 'IntersectionObserver' in window) {
        const observer = new IntersectionObserver(
          ([entry]) => {
            const visible = !entry.isIntersecting;
            sticky.hidden = !visible;
            sticky.classList.toggle('is-visible', visible);
            document.body.classList.toggle('l-pdp-has-sticky', visible);
          },
          { threshold: 0, rootMargin: '0px 0px 0px 0px' }
        );
        observer.observe(buyRow);
      }

      const variantId = variantInput?.value;
      const initial = product.variants.find((v) => String(v.id) === String(variantId))
        || product.variants.find((v) => v.available)
        || product.variants[0];
      if (initial) setVariant(initial);
      if (thumbs.length) setMedia(0);
      else if (media.length) setMedia(0);
      syncWishlistState(root, product.handle);
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initPdp);
  } else {
    initPdp();
  }

  document.addEventListener('shopify:section:load', initPdp);
})();
